import Document from "../utils/services/documentService.js";
import crudTemplate from "../templates/crudTemplate";
import massTemplate from "../templates/massTemplate";
let crud = crudTemplate(Document);
const state = {
  ...crud.state
};
const getters = {
  ...crud.getters
};

const actions = {
  ...crud.actions,
  ...massTemplate(Document, "move").actions,
  ...massTemplate(Document, "copy").actions,
  previewData(
    _,
    { item, errorHandler = () => {}, onError = () => {}, onSuccess = () => {} }
  ) {
    return Document.previewData({ ...item }, onSuccess, onError, errorHandler);
  },
  previewHTML(_, { item, onSuccess = () => {} }) {
    return Document.previewHTML({ ...item }, onSuccess);
  },
  exportPDF(_, { item, onSuccess = () => {} }) {
    return Document.previewPDF({ ...item }, onSuccess);
  },
  massExport(_, { ids, onSuccess }) {
    return Document.massExport({ ids }, onSuccess);
  },
  updateList(
    _,
    {
      ids,
      values,
      errorHandler = () => {},
      onError = () => {},
      onSuccess = () => {}
    }
  ) {
    return Document.updateList(ids, values, onSuccess, onError, errorHandler);
  }
};

const mutations = {
  ...crud.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
